import { BALANCE_HISTORY_TO_FILTERS_MAP } from '@/app/shared/constants/balance-history';
import { PriceType } from '@app/shared/types/common';

export const getFiltersFromBalanceHistoryType = (type: PriceType | null) =>
  BALANCE_HISTORY_TO_FILTERS_MAP[type ?? ''];
